"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var FlexibleIcon = function FlexibleIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-flexible",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.96 92",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M58,16a2,2,0,0,1-1.41-.59L46,4.83,35.41,15.41a2,2,0,0,1-2.82-2.82l12-12a2,2,0,0,1,2.82,0l12,12A2,2,0,0,1,58,16Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M46,55a2,2,0,0,1-2-2V4.63a2,2,0,0,1,4,0V53A2,2,0,0,1,46,55Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M46,92a2,2,0,0,1-2-2V80A44.05,44.05,0,0,1,88,36a2,2,0,0,1,0,4A40,40,0,0,0,48,80V90A2,2,0,0,1,46,92Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M39.79,60a2,2,0,0,1-1.71-1A39.78,39.78,0,0,0,4,40a2,2,0,0,1,0-4A43.76,43.76,0,0,1,41.49,57a2,2,0,0,1-1.7,3Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M79,52a2,2,0,0,1-1.41-3.41L88.13,38,77.55,27.42a2,2,0,0,1,2.83-2.83l12,12a2,2,0,0,1,0,2.83l-12,12A2,2,0,0,1,79,52Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M14,52a2,2,0,0,1-1.41-.59l-12-12a2,2,0,0,1,0-2.83l12-12a2,2,0,0,1,2.83,2.83L4.83,38,15.41,48.59A2,2,0,0,1,14,52Z"
  }))));
};

var _default = FlexibleIcon;
exports["default"] = _default;